<template>
  <div class="page-container">
    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <span class="md-title"><slot name="title"></slot></span>
        <div class="md-toolbar-section-end">
          &copy; vorbild-schule.de | <a href="https://vorbild-schule.de/impressum/" style="color: white; margin: 0 5px"  target="_blank">Impressum</a><a style="color: white" href="https://vorbild-schule.de/datenschutzerklaerung/" target="_blank">Datenschutz</a>
        </div>
      </md-app-toolbar>

      <md-app-content>
        <slot name="content"></slot>
      </md-app-content>
    </md-app>
  </div>
</template>

<style lang="scss" scoped>
.md-app {
  min-height: 100vh;
  border: 1px solid rgba(#000, 0.12);
}

.md-drawer {
  width: 230px;
  max-width: calc(100vw - 20px);
}

.md-app-content {
  padding-top: 30px;
}
</style>

<script>
export default {
  name: "Reveal",
  data: () => ({
    menuVisible: false
  })
};
</script>
